import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import { Control } from 'react-hook-form';
import { IoListOutline } from 'react-icons/io5';
import { AiOutlineAppstore } from 'react-icons/ai';
import copy from 'copy-to-clipboard';

import DateRangePicker from '@/components/Common/DateRangePicker';
import { OnboardingListFormValues } from '../constants';

export type OnboardingViewMode = 'list' | 'insights';

interface OnboardingHeaderProps {
  control: Control<OnboardingListFormValues>;
  viewMode: OnboardingViewMode;
  onViewModeChange: (mode: OnboardingViewMode) => void;
  createdAt?: string;
}

export default function OnboardingHeader({ control, viewMode, onViewModeChange, createdAt }: OnboardingHeaderProps) {
  const theme = useTheme();

  return (
    <Box
      display='flex'
      flexDirection={{ xs: 'column', lg: 'row' }}
      justifyContent='space-between'
      alignItems={{ xs: 'flex-start', lg: 'center' }}
      gap={2}
      mb={2}
    >
      <Typography variant='h6' fontWeight={500}>
        Business Onboarding
      </Typography>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        gap={1.5}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        width={{ xs: '100%', lg: 'auto' }}
      >
        {viewMode === 'list' && (
          <Box minWidth={{ xs: '100%', sm: 260 }}>
            <DateRangePicker name='date' control={control} createdAt={createdAt} />
          </Box>
        )}

        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(_, value) => value && onViewModeChange(value)}
          sx={{
            backgroundColor: '#fff',
            borderRadius: '999px',
            padding: '3px',
            display: 'flex',
            gap: '2px',
            alignSelf: { xs: 'stretch', sm: 'auto' },
            '& .MuiToggleButton-root': {
              border: 'none',
              textTransform: 'none',
              fontSize: 14,
              fontWeight: 500,
              color: '#6B7280',
              borderRadius: '999px',
              padding: '6px 14px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              flex: { xs: 1, sm: 'none' },
              justifyContent: 'center'
            },
            '& .Mui-selected': {
              backgroundColor: `${theme.palette.primary.main} !important`,
              color: '#fff !important',
              boxShadow: '0px 2px 6px rgba(0,0,0,0.12)'
            }
          }}
        >
          <ToggleButton value='list'>
            <IoListOutline size={16} />
            List
          </ToggleButton>
          <ToggleButton value='insights'>
            <AiOutlineAppstore size={16} />
            Insights
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Box>
  );
}

export function copyOnboardingLink(showToast: (message: string, type: 'success' | 'error') => void) {
  const formLink = `${window.location.origin}/business-onboarding`;
  copy(formLink);
  showToast('Onboarding Link has been copied successfully', 'success');
}
